'use client';
import Image from '@/components/Image';
import { useStore } from '@/providers/app-store-provider';
import { useTranslations } from '@/i18n/use-translations';

interface GiftPopoverProps {
  show: boolean;
  giftCount: number;
}

const GiftPopover: React.FC<GiftPopoverProps> = ({ show, giftCount }) => {
  const waiMode = useStore((state) => state.waiMode);
  const t = useTranslations('layout.header');
  return (
    <div
      className={`absolute h-[29px] min-w-max top-[25px] right-[-3px] bg-[url('/zeelool-next/layout/header_gift_bg.png')] bg-[length:100%_100%] bg-[position:0_bottom] box-border flex items-center z-[1000] transition-all duration-1000 ease-in-out
       ${
         show
           ? 'scale-100 translate-x-0 translate-y-0'
           : 'scale-0 translate-x-[30px] -translate-y-[10px] top-0'
       }
       ${waiMode ? 'bg-primary-black' : ''}
      `}
    >
      <Image src="/layout/header_gift.png" alt="Gift" width={28} height={28} className="pt-[3px]" />
      <span className="text-white text-[11px] ml-[2px] pt-[4px] block font-bs">{t('GIFT')}</span>
      <span className="text-white text-[11px] ml-[4px] pt-[4px] font-bs">X {giftCount}</span>
    </div>
  );
};

export default GiftPopover;
